import {
  FormControlLabel,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MasterService from "../../../Masters/MasterService";
import Swal from "sweetalert2";
import moment from 'moment'
import { OSSwitch } from "../../../NewUI/NewComponents/OSSwitch.jsx";
import { ChevronLeft, ChevronRight, Search } from "lucide-react";


const SuperAdminDashboard = () => {
  const [clientsdata, setClientsdata] = useState([]);
  const [allClientsdata, setAllClientsdata] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false)
  const [clientSearch,setClientSearch] = useState("")

  useEffect(() => {
    setLoading(true)
    MasterService.retriveAllTenants().then((res) => {
      setClientsdata(
        res.data === "" || res.data === undefined
          ? []
          : res.data.sort((a, b) => (a.id < b.id ? -1 : 1))
      );
      setAllClientsdata(
        res.data === "" || res.data === undefined
          ? []
          : res.data.sort((a, b) => (a.id < b.id ? -1 : 1))
      );
      setLoading(false)
    })
      .catch(() => setLoading(false))
  }, []);

  useEffect(() => {
    if(clientSearch === ""){  
      setClientsdata(allClientsdata)
    }else{
      setClientsdata(allClientsdata.filter(c => (c.id.toLowerCase().includes(clientSearch.toLowerCase())) || (c.companyname && c.companyname.toLowerCase().includes(clientSearch.toLowerCase())) || (c.contactname && c.contactname.toLowerCase().includes(clientSearch.toLowerCase())) || (c.phonenoc && c.phonenoc.phoneno && c.phonenoc.phoneno.toLowerCase().includes(clientSearch.toLowerCase()))))  
    }
  }, [clientSearch])



  const handleChangePage = (event, newPage) => {
    console.log(newPage)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const visibleRows = React.useMemo(
    () =>
      clientsdata?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      )
    // [ page, rowsPerPage],
  );

  const extendTrail = (id) => {
    Swal.fire({
      title: `Start trail period for the next 30 days.`,
      text: "Are you sure?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        MasterService.extendTrailPeriod(id)
          .then(() => {
            MasterService.retriveAllTenants().then((res) =>
              setClientsdata(
                res.data === "" || res.data === undefined
                  ? []
                  : res.data.sort((a, b) => (a.id < b.id ? -1 : 1))
              )
            );
            Swal.fire({
              title: `Client trail period has started for the next 15 days.`,
              text: ".",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          })
          .catch((error) =>
            Swal.fire({
              title: `Request failed: ${error.data}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            })
          );
      }
    });
  };

  const handleSubscription = (client) => {
    if (client.enguagment === "NA") {
      handleSelectEnguagment(client);
    } else {
      let data = {
        id: client.id,
        duration:
          client.enguagment === "SAASMonthly"
            ? moment(new Date())
              .add("1", "month")
              .diff(moment(new Date()), "days")
            : client.enguagment === "SAASQuarterly"
              ? moment(new Date())
                .add("3", "month")
                .diff(moment(new Date()), "days")
              : moment(new Date())
                .add("1", "year")
                .diff(moment(new Date()), "days"),
        plan:
          client.enguagment === "SAASMonthly"
            ? moment(new Date())
              .add("1", "month")
              .diff(moment(new Date()), "days")
            : client.enguagment === "SAASQuarterly"
              ? moment(new Date())
                .add("3", "month")
                .diff(moment(new Date()), "days")
              : moment(new Date())
                .add("1", "year")
                .diff(moment(new Date()), "days"),
      };
      Swal.fire({
        title: `Payment Received, Make client as Active`,
        text: "Are you sure?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#152f5f",
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          MasterService.PaymentStatusUpdate(data)
            .then(() => {
              MasterService.retriveAllTenants().then((res) =>
                setClientsdata(
                  res.data === "" || res.data === undefined
                    ? []
                    : res.data.sort((a, b) => (a.id < b.id ? -1 : 1))
                )
              );
              Swal.fire({
                title: `Client has been successfully ${client.status === "ACTIVE" ? "Inactivated" : "activated"
                  }`,
                text: ".",
                icon: "success",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              });
            })
            .catch((error) =>
              Swal.fire({
                title: `Request failed: ${error.data}`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              })
            );
        }
      });
    }
  };

  const handleSelectEnguagment = async (client) => {
    const { value: formValues } = await Swal.fire({
      title: `Select Enguagment Type for ${client.companyname}`,
      input: "select",
      inputOptions: {
        SAASMonthly: "SAAS Monthly",
        SAASQuarterly: "SAAS Quarterly",
        SAASYearly: "SAAS Yearly",
      },
      confirmButtonColor: "#152f5f",
      inputPlaceholder: "Select Enguagment Type",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      inputValidator: (value) => {
        return new Promise((resolve) => {
          resolve();
        });
      },
    });
    if (formValues) {
      let data = {
        id: client.id,
        enguagment: formValues,
      };
      MasterService.ChangeEnguagment(data)
        .then(() => {
          MasterService.retriveAllTenants().then((res) =>
            setClientsdata(
              res.data === "" || res.data === undefined
                ? []
                : res.data.sort((a, b) => (a.id < b.id ? -1 : 1))
            )
          );
          Swal.fire({
            title: `Client's Enguagment Type has been successfully Updated`,
            text: ".",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          });
        })
        .catch((error) =>
          Swal.fire({
            title: `Request failed: ${error.data}`,
            text: ".",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          })
        );
    }
  };

  const handleStatusChange = (client) => {
    if (client.plantype !== "NA" && client.days > 0) {
      Swal.fire({
        title: `Make client as ${client.status === "ACTIVE" ? "Inactive" : "Active"
          }`,
        text: "Are you sure?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#152f5f",
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          MasterService.InactiveClient(client.id)
            .then(() => {
              MasterService.retriveAllTenants().then((res) =>
                setClientsdata(
                  res.data === "" || res.data === undefined
                    ? []
                    : res.data.sort((a, b) => (a.id < b.id ? -1 : 1))
                ));
              Swal.fire({
                title: `Client has been successfully ${client.status === "ACTIVE" ? "Inactivated" : "activated"
                  }`,
                text: ".",
                icon: "success",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              });
            })
            .catch((error) =>
              Swal.fire({
                title: `Request failed: ${error.data}`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              })
            );
        }
      });
    } else {
      Swal.fire({
        title: `Please make a payment or start a trail in order to activate the client`,
        text: ".",
        icon: "warning",
        confirmButtonText: "Ok",
        confirmButtonColor: "#152f5f",
      });
    }
  };



  return (
    <div>
      {/* <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            className="table-sm p-2 pb-4"
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell>Client Id</TableCell>
                <TableCell>Company Name</TableCell>
                <TableCell>Contact Name</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Trail</TableCell>
                <TableCell>Payment</TableCell>
                <TableCell>Enguagment Type</TableCell>
                <TableCell>Active Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ?
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <Skeleton variant="rounded" height={20} width="100%" animation="wave" />
                  </TableCell>
                </TableRow> :
                visibleRows === null && visibleRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      Sorry, no data avilable
                    </TableCell>
                  </TableRow>
                ) : (
                  visibleRows?.map((client, index) => (
                    <TableRow key={index}>
                      <TableCell>{client.id}</TableCell>
                      <TableCell>{client.companyname}</TableCell>
                      <TableCell>{client.contactname}</TableCell>
                      <TableCell>
                        +{client.phonecode} {client.contactnumber}
                      </TableCell>
                      <TableCell>
                        {client.trailstatus !== "Active" && client.plantype !== "Subscription" &&
                          client.plantype !== "Trail" ? (
                          <button
                            className="btn btn-sm hovbuttonColour"
                            onClick={() => extendTrail(client.id)}
                          >
                            Start
                          </button>
                        ) : client.trailstatus === "Active" ? (
                          `${client.days}/${client.plan}`
                        ) : (
                          client.trailstatus ? client.trailstatus : "Subscribed"
                        )}
                      </TableCell>
                      <TableCell>
                        {client.plantype === "Subscription" ? (
                          `Received`
                        ) : (
                          <button
                            className="btn btn-sm hovbuttonColour"
                            onClick={() => handleSubscription(client)}
                          >
                            Pending
                          </button>
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        className="cursorpointer"
                        onClick={() => handleSelectEnguagment(client)}
                      >
                        {client.enguagment === null ||
                          client.enguagment === undefined
                          ? "NA"
                          : client.enguagment}
                        <i className="fas fa-caret-down ml-1"></i>
                      </TableCell>
                      <TableCell>
                        <FormControlLabel
                          control={
                            <OSSwitch
                              checked={client.clientactive === "ACTIVE" ? true : false}
                              onChange={() => handleStatusChange(client)}
                            />
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10]}
          component="div"
          count={clientsdata.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper> */}

 <section id="fin-year-clients-card" className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-2xl tw-shadow-xs tw-overflow-hidden">
        
        {/* Header Block exactly corresponding to image layout */}
        <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-100 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4">

                <h2>Tenants</h2>
          <div className="tw-flex tw-items-center tw-gap-4 tw-text-xs tw-font-semibold tw-text-slate-500">
            {/* In-tab search feature */}
            <div className="tw-relative">
              <input 
                type="text"
                placeholder="Search clients..."
                value={clientSearch}
                onChange={(e) => setClientSearch(e.target.value)}
                className="tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-pl-8 tw-pr-3 tw-py-1.5 tw-w-48 tw-text-xs tw-font-semibold tw-focus:outline-none tw-focus:border-blue-500"
              />
              <Search size={13} className="tw-absolute tw-left-2.5 tw-top-1/2 tw--translate-y-1/2 tw-text-slate-400" />
            </div>
          </div>
        </div>

       <div className="tw-overflow-x-auto">
          <table className="tw-w-full tw-text-xs tw-text-left tw-text-slate-600 tw-border-collapse">
            <thead>
              <tr className="tw-bg-slate-50 tw-text-slate-500 tw-border-b tw-border-slate-100 tw-font-extrabold tw-text-[10px] tw-tracking-wide tw-uppercase">
                <th className="tw-px-6 tw-py-3.5">Client Id</th>
                <th className="tw-px-6 tw-py-3.5">Company Name</th>
                <th className="tw-px-6 tw-py-3.5">Contact Name</th>
                <th className="tw-px-6 tw-py-3.5">Contact Number</th>
                <th className="tw-px-6 tw-py-3.5 tw-text-center">Trail</th>
                <th className="tw-px-6 tw-py-3.5 tw-text-center">Payment</th>
                <th className="tw-px-6 tw-py-3.5 tw-text-center">Enguagment Type</th>
                <th className="tw-px-6 tw-py-3.5 tw-text-center">Active Status</th>
              </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-slate-100 tw-font-medium">
              {visibleRows.map((c, idx) => (
                <tr key={c.id} className="tw-hover:bg-slate-50/50 tw-transition-all hover:tw-bg-blue-50 hover:tw-shadow">
                  <td className="tw-px-6 tw-py-3 tw-font-bold tw-text-slate-900 tracking-tight">{c.id}</td>
                  <td className="tw-px-6 tw-py-3 tw-text-slate-700">{c.companyname}</td>
                  <td className="tw-px-6 tw-py-3 tw-text-slate-500">{c.contactname}</td>
                  <td className="tw-px-6 tw-py-3 tw-font-mono tw-text-slate-400">{c.contactnumber}</td>
                  <td className="tw-px-6 tw-py-3" align="center">
                    <span className={`tw-px-2 tw-py-0.5 rounded-full text-[10px] font-bold ${
                      c.trailstatus !== "Active" && c.plantype !== "Subscription" && c.plantype !== "Trail"? "":
                      c.trailstatus === 'Active' ? ' font-extrabold ' :
                      c.trailstatus? 'tw-bg-orange-50 tw-text-orange-600':
                     'tw-bg-indigo-50 tw-text-indigo-600'
                    }`}>
                       {c.trailstatus !== "Active" && c.plantype !== "Subscription" && c.plantype !== "Trail" ? (
                          <button className="btn btn-sm hovbuttonColour" onClick={() => extendTrail(c.id)}> Start</button>
                        ) : c.trailstatus === "Active" ? (
                          `${c.days}/${c.plan}`
                        ) : (
                          c.trailstatus ? c.trailstatus : "Subscribed"
                        )}
                    </span>
                  </td>
                  <td className="tw-px-6 tw-py-3" align="center">
                    {c.plantype === "Subscription" ?  <span className={`tw-inline-flex items-center gap-1 font-bold text-[10px] tw-px-2 tw-py-0.5 rounded ${
                      c.payment === 'Received' ? 'tw-bg-emerald-50 tw-text-emerald-600' : 'tw-bg-slate-100 tw-text-slate-500 font-black'
                    }`}>
                      {c.payment === 'Pending' ? 'Pending' : 'Received'}
                    </span>:
                    <button
                            className="btn btn-sm hovbuttonColour"
                            onClick={() => handleSubscription(c)}
                          >
                            Pending
                          </button>
                    }
                  </td>
                  <td className="tw-px-6 tw-py-3 cursorpointer" onClick={() => handleSelectEnguagment(c)} align="center">
                    {c.enguagment === null ||
                          c.enguagment === undefined
                          ? "NA"
                          : c.enguagment}
                        <i className="fas fa-caret-down ml-1"></i>
                  </td>
                  <td className="tw-px-6 tw-py-3" align="center">
                    {/* <button
                      onClick={() => toggleClientActive(c.id)}
                      className="focus:outline-none transition-transform active:scale-95 inline-block"
                      title={c.active ? "Click to deactivate" : "Click to activate"}
                    >
                      <div className={`w-9 h-5 rounded-full p-0.5 transition-colors duration-200 ${c.active ? 'tw-bg-slate-800' : 'tw-bg-slate-200'}`}>
                        <div className={`w-4 h-4 rounded-full tw-bg-white tw-shadow-xs transition-transform duration-200 ${c.active ? 'transform translate-x-4' : ''}`} />
                      </div>
                    </button> */}
                    <OSSwitch
                              checked={c.clientactive === "ACTIVE" ? true : false}
                              onChange={() => handleStatusChange(c)}
                            />
                  </td>
                </tr>
              ))}
              {visibleRows.length === 0 && (
                <tr>
                  <td colSpan="8" className="tw-px-6 tw-py-10 text-center text-slate-400">
                    No clients discovered matching the query.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer Pagination control */}
        <div className="tw-px-6 tw-py-3 tw-border-t tw-border-slate-100 tw-flex tw-items-center tw-justify-end tw-text-xs tw-text-slate-400 tw-font-bold tw-gap-4">
          <div className="tw-flex tw-items-center tw-gap-2">
            <span>Rows per page:</span>
            <select 
              value={rowsPerPage}
              onChange={(e) => { handleChangeRowsPerPage(e)}}
              className="tw-bg-transparent tw-font-black tw-text-slate-705 tw-border-0 tw-focus:ring-0 tw-cursor-pointer tw-text-xs tw-mt-2"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
            </select>
          </div>
          <span>
            {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, visibleRows.length)} of {clientsdata.length}
          </span>
          <div className="tw-flex tw-items-center tw-gap-2">
            <button 
              disabled={page === 0}
              onClick={(e) => handleChangePage(e, page - 1)}
              className="tw-p-1 tw-hover:bg-slate-100 tw-disabled:opacity-30 tw-rounded tw-cursor-pointer"
            >
              <ChevronLeft size={14} />
            </button>
            <button 
              disabled={(page + 1) * rowsPerPage >= clientsdata.length}
              onClick={(e) => handleChangePage(e, page + 1)}
              className="tw-p-1 tw-hover:bg-slate-100 tw-disabled:opacity-30 tw-rounded tw-cursor-pointer"
            >
              <ChevronRight size={14} />
            </button>
          </div>
        </div>
    </section>
    </div>
  );
};

export default SuperAdminDashboard;
